import { mountMainButton } from '@telegram-apps/sdk-react';

import { isTelegramConfigured, useMainButton } from '@/telegram';

export interface MainActionProps {
  text: string;
  enabled?: boolean;
  onPress: () => void;
}

/**
 * Нижняя кромка экрана, отданная действию: нативная Telegram MainButton внутри
 * приложения, запасная кнопка в разметке вне его. `useMainButton` тихо ничего
 * не делает, когда MainButton недоступна (обычный браузер, VITE_DEV_OFFLINE),
 * и тогда экран остаётся непроходимым без явной замены — composition поэтому
 * решает сама, mountMainButton.isAvailable() читается один раз при инициализации
 * Telegram-слоя (src/telegram/init.ts, вызывается синхронно из bootstrap ещё до
 * первого рендера) и дальше не меняется за время жизни вкладки.
 */
export function MainAction({ text, enabled = true, onPress }: MainActionProps) {
  useMainButton({ text, enabled }, onPress);

  if (isTelegramConfigured() && mountMainButton.isAvailable()) return null;

  return (
    <button
      type="button"
      onClick={onPress}
      disabled={!enabled}
      className="h-tap w-full shrink-0 appearance-none rounded-none bg-acc px-5 text-left font-display text-btn uppercase text-ground disabled:bg-off disabled:text-mute"
    >
      {text}
    </button>
  );
}
